import { Button, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import IntlMessages from "../../../../../util/IntlMessages";
import { ActionDialog } from "../../../../generic/ActionDialog";

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const EditEmailDialog = ({ beneficiary, open, handleClose, onSubmit }) => {
  const intl = useIntl();
  const [email, setEmail] = useState(beneficiary?.email || "");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setEmail(beneficiary?.email || "");
      setError("");
    }
  }, [open, beneficiary?.email]);

  const validate = (value) => {
    if (!value) {
      return intl.formatMessage({ id: "validation.fieldCannotBeEmpty" });
    }
    if (!EMAIL_PATTERN.test(value)) {
      return intl.formatMessage({
        id: "pages.beneficiaryDetail.editEmail.invalidFormat",
      });
    }
    return "";
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (error) {
      setError(validate(value));
    }
  };

  const handleSubmit = async () => {
    const validationError = validate(email);
    if (validationError) {
      setError(validationError);
      return;
    }
    await onSubmit(email);
  };

  return (
    <ActionDialog
      open={open}
      onClose={handleClose}
      title={<IntlMessages id="pages.beneficiaryDetail.editEmail" />}
      content={
        <TextField
          id="edit-email-input"
          name="email"
          type="email"
          label={intl.formatMessage({ id: "common.contactEmail" })}
          value={email}
          onChange={handleChange}
          error={!!error}
          helperText={error}
          fullWidth
          margin="normal"
          inputProps={{ maxLength: 250 }}
        />
      }
      actions={
        <>
          <Button id="cancel" onClick={handleClose}>
            <IntlMessages id="common.cancel" />
          </Button>
          <Button
            id="submit"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            <IntlMessages id="common.save" />
          </Button>
        </>
      }
    />
  );
};

export { EditEmailDialog };
